module.exports = __webpack_public_path__ + "static/img/10.dbdec6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/10.png
// module id = 8RQM
// module chunks = 1